// Generated by purs version 0.14.4
import * as $foreign from "./foreign.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_FoldableWithIndex from "../Data.FoldableWithIndex/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Type_Data_RowList from "../Type.Data.RowList/index.js";
var FromJSONKeyString = (function () {
    function FromJSONKeyString(value0) {
        this.value0 = value0;
    };
    FromJSONKeyString.create = function (value0) {
        return new FromJSONKeyString(value0);
    };
    return FromJSONKeyString;
})();
var FromJSONKeyValue = (function () {
    function FromJSONKeyValue(value0) {
        this.value0 = value0;
    };
    FromJSONKeyValue.create = function (value0) {
        return new FromJSONKeyValue(value0);
    };
    return FromJSONKeyValue;
})();
var unsafeDecode = function (dict) {
    return dict.unsafeDecode;
};
var recordInfo = function (dict) {
    return dict.recordInfo;
};
var fromJSONKeyString = {
    fromJSONKey: new FromJSONKeyString(Control_Category.identity(Control_Category.categoryFn))
};
var fromJSONKey = function (dict) {
    return dict.fromJSONKey;
};
var defaultFromJSONKeyValue = function (dictDecode) {
    return new FromJSONKeyValue(unsafeDecode(dictDecode));
};
var decode_Unit = {
    unsafeDecode: function (v) {
        return Data_Unit.unit;
    }
};
var decode_Tuple = function (dictDecode) {
    return function (dictDecode1) {
        return {
            unsafeDecode: function (v) {
                var v1 = $foreign.expectArray(v);
                if (v1.length === 2) {
                    return new Data_Tuple.Tuple(unsafeDecode(dictDecode)(v1[0]), unsafeDecode(dictDecode1)(v1[1]));
                };
                return $foreign.decodingError("Invalid array length in Tuple representation");
            }
        };
    };
};
var decode_String = {
    unsafeDecode: $foreign.decodeString
};
var decode_Set = function (dictDecode) {
    return function (dictOrd) {
        return {
            unsafeDecode: (function () {
                var $50 = Data_Set.fromFoldable(Data_Foldable.foldableArray)(dictOrd);
                var $51 = $foreign.decodeArray(unsafeDecode(dictDecode));
                return function ($52) {
                    return $50($51($52));
                };
            })()
        };
    };
};
var decode_Record = function (dictRowToList) {
    return function (dictDecodeRecord) {
        return {
            unsafeDecode: $foreign.decodeRecord(recordInfo(dictDecodeRecord)(Type_Data_RowList.RLProxy.value))
        };
    };
};
var decode_Object = function (dictDecode) {
    return {
        unsafeDecode: $foreign.decodeObject(unsafeDecode(dictDecode))
    };
};
var decode_Number = {
    unsafeDecode: $foreign.decodeNumber
};
var decode_NonEmptyArray = function (dictDecode) {
    return {
        unsafeDecode: function (f) {
            var v = Data_Array_NonEmpty.fromArray($foreign.decodeArray(unsafeDecode(dictDecode))(f));
            if (v instanceof Data_Maybe.Just) {
                return v.value0;
            };
            if (v instanceof Data_Maybe.Nothing) {
                return $foreign.decodingError("NonEmptyArray should not be empty");
            };
            throw new Error("Failed pattern match at Unscramble (line 64, column 5 - line 68, column 58): " + [ v.constructor.name ]);
        }
    };
};
var decode_Maybe = function (dictDecode) {
    return {
        unsafeDecode: function (value) {
            var $43 = Foreign.isNull(value) || Foreign.isUndefined(value);
            if ($43) {
                return Data_Maybe.Nothing.value;
            };
            return new Data_Maybe.Just(unsafeDecode(dictDecode)(value));
        }
    };
};
var decode_Int = {
    unsafeDecode: $foreign.decodeInt
};
var decode_Foreign = {
    unsafeDecode: function (x) {
        return x;
    }
};
var decode_Boolean = {
    unsafeDecode: $foreign.decodeBoolean
};
var decode_Array = function (dictDecode) {
    return {
        unsafeDecode: $foreign.decodeArray(unsafeDecode(dictDecode))
    };
};
var decode_Map = function (dictFromJSONKey) {
    return function (dictOrd) {
        return function (dictDecode) {
            return {
                unsafeDecode: function (v) {
                    var v1 = fromJSONKey(dictFromJSONKey);
                    if (v1 instanceof FromJSONKeyString) {
                        return Data_FoldableWithIndex.foldlWithIndex(Foreign_Object.foldableWithIndexObject)(function (k) {
                            return function (acc) {
                                return function (v2) {
                                    return Data_Map_Internal.insert(dictOrd)(v1.value0(k))(unsafeDecode(dictDecode)(v2))(acc);
                                };
                            };
                        })(Data_Map_Internal.empty)($foreign.expectObject(v));
                    };
                    if (v1 instanceof FromJSONKeyValue) {
                        return Data_Foldable.foldl(Data_Foldable.foldableArray)(function (acc) {
                            return function (v2) {
                                return Data_Map_Internal.insert(dictOrd)(v1.value0(v2.value0))(unsafeDecode(dictDecode)(v2.value1))(acc);
                            };
                        })(Data_Map_Internal.empty)(unsafeDecode(decode_Array(decode_Tuple(decode_Foreign)(decode_Foreign)))(v));
                    };
                    throw new Error("Failed pattern match at Unscramble (line 107, column 5 - line 111, column 142): " + [ v1.constructor.name ]);
                }
            };
        };
    };
};
var decodeRecordNil = {
    recordInfo: function (v) {
        return $foreign.recordInfoNil;
    }
};
var decodeRecordCons = function (dictIsSymbol) {
    return function (dictDecode) {
        return function (dictDecodeRecord) {
            return {
                recordInfo: function (v) {
                    return $foreign.recordInfoCons(Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value))(unsafeDecode(dictDecode))(recordInfo(dictDecodeRecord)(Type_Data_RowList.RLProxy.value));
                }
            };
        };
    };
};
var catchDecodingErrorEither = $foreign.catchDecodingErrorImpl(Data_Either.Left.create)(Data_Either.Right.create);
var decodeEither = function (dictDecode) {
    return function (value) {
        return catchDecodingErrorEither(function (v) {
            return unsafeDecode(dictDecode)(value);
        });
    };
};
var decodeJSONEither = function (dictDecode) {
    return function (value) {
        return catchDecodingErrorEither(function (v) {
            return unsafeDecode(dictDecode)($foreign.unsafeParseJSON(value));
        });
    };
};
var catchDecodingError = $foreign.catchDecodingErrorImpl(function (v) {
    return Data_Maybe.Nothing.value;
})(Data_Maybe.Just.create);
var decode = function (dictDecode) {
    return function (value) {
        return catchDecodingError(function (v) {
            return unsafeDecode(dictDecode)(value);
        });
    };
};
var decodeJSON = function (dictDecode) {
    return function (value) {
        return catchDecodingError(function (v) {
            return unsafeDecode(dictDecode)($foreign.unsafeParseJSON(value));
        });
    };
};
export {
    decodingError,
    recordInfoNil,
    recordInfoCons,
    decodeRecord,
    isString,
    decodeString,
    isNumber,
    decodeNumber,
    decodeInt,
    decodeBoolean,
    decodeArray,
    decodeObject,
    expectObject,
    expectArray,
    unsafeParseJSON,
    catchDecodingErrorImpl
} from "./foreign.js";
export {
    fromJSONKey,
    recordInfo,
    unsafeDecode,
    decode,
    decodeEither,
    decodeJSON,
    decodeJSONEither,
    defaultFromJSONKeyValue,
    FromJSONKeyString,
    FromJSONKeyValue,
    catchDecodingError,
    catchDecodingErrorEither,
    decode_Foreign,
    decode_Unit,
    decode_String,
    decode_Number,
    decode_Int,
    decode_Boolean,
    decode_Array,
    decode_NonEmptyArray,
    decode_Tuple,
    decode_Object,
    decode_Record,
    decode_Maybe,
    decode_Set,
    fromJSONKeyString,
    decode_Map,
    decodeRecordNil,
    decodeRecordCons
};
//# sourceMappingURL=index.js.map
